export default __webpack_public_path__ + "static/media/not-authorized.59f4e57d.png";